'use client'

import * as React from "react"
import { UserContextProvider, useUserContext } from "./user-provider"
import { SidebarProvider, useSidebar } from "@/components/sidebar/sidebar-provider"
import { DragDropProvider } from "./drag-drop-provider"
import { User } from "@/lib/types/user-types"



export function Providers({
    children,
    userContextProviderValue,
    sidebarDefaultOpen = true,
}: {
    children: React.ReactNode,
    userContextProviderValue: User | null,
    sidebarDefaultOpen?: boolean,
}) {
    return (
        <UserContextProvider
            initialUser={userContextProviderValue}
        >
            <DragDropProvider>
                <SidebarProvider defaultOpen={sidebarDefaultOpen}>
                    {children}
                </SidebarProvider>
            </DragDropProvider>
        </UserContextProvider>
    )
}

// Export all providers
export { UserContextProvider, useUserContext } from "./user-provider"
export { SidebarProvider, useSidebar } from "@/components/sidebar/sidebar-provider"
export { UrlParamsProvider, getStoredUrlParams } from "./url-params-provider"
export { DragDropProvider, useDragDrop } from "./drag-drop-provider"